// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productivity-tip__info-icon path{fill:#7a2ba8;transition:fill .2s ease}.productivity-tip__info-btn:hover .productivity-tip__info-icon path{fill:#a94fd2}.productivity-tip__info-btn:active .productivity-tip__info-icon path{fill:#36134a}", ""]);
// Exports
module.exports = exports;
